/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { ofType, StateObservable } from "redux-observable";
import { Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { IAppState } from "../types";
import { DataProvider } from "../../providers";
import * as Actions from "./actions";
import * as Consts from "./consts";
import * as Types from "./types";
import { toError, toSuccess } from "../operators";

const getOffersEpic = (
  action$: Observable<Types.IGetOffersAction>,
  state$: StateObservable<IAppState>
) =>
  action$.pipe(
    ofType(Consts.GET_OFFERS),
    switchMap(() =>
      DataProvider.getOffers({
        UtmCampaign: state$.value.auth.user?.UtmCampaign,
      }).pipe(
        map((offers) => Actions.getOffersSuccess(offers)),
        toError(Actions.getOffersFailure)
      )
    )
  );

const getPaymentInvoicesEpic = (
  action$: Observable<Types.IGetPaymentInvoicesAction>
) =>
  action$.pipe(
    ofType(Consts.GET_PAYMENT_INVOICES),
    switchMap(() =>
      DataProvider.getPaymentInvoices().pipe(
        map((response) => response.filter((data) => data.PaymentSuccess)),
        toSuccess(Actions.getPaymentInvoicesSuccess),
        toError(Actions.getPaymentInvoicesFailure)
      )
    )
  );

export const paymentsEpics = [getOffersEpic, getPaymentInvoicesEpic];
